import { useTranslations } from 'next-intl';
import { TypeformSnippet } from '..';
import styles from './PartnersTypeform.module.css';

export const PartnersTypeform = () => {
  const t = useTranslations('partners');
  return (
    <div className={styles.container}>
      <TypeformSnippet
        typeformId="mRmbCYc5"
        frameTitle={t('typeform.frameTitle')}
        className="typeform-container"
      />
    </div>
  );
};
